// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ActionType {
  LobbyClaimPlayerSlot = 500,
  LobbySetBotPlayerSlot = 501,
  LobbyReservePlayerSlot = 502,
  LobbyLeavePlayerSlot = 503,
  LobbyKickPlayerSlot = 504,
  LobbyInvitePlayerSlot = 505,
  LobbySwapPlayerSlot = 506,
  LobbyPatchPlayerSlot = 507,
  LobbyPatchConfig = 508,
  LobbyStartNewGame = 509,
  LobbyDeleteLobby = 510,
  LobbyRestoreLobby = 511,
  MapSetState = 1000,
  MapPatchMap = 1001,
  MapPaintTile = 1002,
  MapEraseTile = 1003,
  MapAddPlayer = 1004,
  MapPatchPlayer = 1005,
  MapDeletePlayer = 1006,
  MapMapToLobby = 1007,
  MapDeleteMap = 1008,
  MapRestoreMap = 1009,
  MapPublishMap = 1010,
  MapUnpublishMap = 1011,
  MapRotateEntity = 1012,
  MapSetEntityElevation = 1013,
  MapSetEnts = 1014,
  MapRownipulatorAddRow = 1015,
  MapRownipulatorDuplicateRow = 1016,
  MapRownipulatorDeleteRow = 1017,
  GameStartRound = 2000,
  GameStartTurn = 2001,
  GameEndTurn = 2002,
  GameEndRound = 2003,
  GamePlaceFactoryOrder = 2004,
  GameCancelFactoryOrder = 2005,
  GameMoveUnit = 2006,
  GameEndGame = 3000
}
